import "@hotwired/turbo-rails"
import 'arrive'
import Venobox from 'venobox'
import * as bootstrap from 'bootstrap'

// sharer.js
import 'sharer.js'
document.addEventListener('turbo:load', function(event) { Sharer.init() })

// make all external links open in new tab
document.arrive('.richtext', { existing: true }, function(el) {
  const selector = "a[href^='http']:not([href^='http://www.evangelikalni-teologie.cz']):not([href^='http://evangelikalni-teologie.cz']):not([href^='https://www.evangelikalni-teologie.cz']):not([href^='https://evangelikalni-teologie.cz'])"
  el.querySelectorAll(selector).forEach(function (e) {e.setAttribute("target", "_blank") })
})

// venobox
document.addEventListener('turbo:load', function () {
  new Venobox({
    selector: '.venobox',
    share: []
  })
})

// umami
import '~/javascript/umami'

// CSS Styles
import '~/stylesheets/application.scss'
